<template>
  <div class="side_nav_wrapper" :class="{ active: navIsActive }">
    <!-- Start:: Toggle Btn -->
    <button class="close_btn" @click="$emit('fireToggleNavDrawerEmit')">
      <i class="fal fa-times"></i>
    </button>
    <!-- End:: Toggle Btn -->

    <!-- Start:: Logo -->
    <div class="logo_wrapper" v-if="getAppTheme == 'light_theme'">
      <router-link class="logo" to="/home">
        <img src="@/assets/media/logo/logo.png" alt="Logo" width="170" height="125" />
      </router-link>
    </div>

    <div class="logo_wrapper" v-else>
      <router-link class="logo" to="/home">
        <img src="@/assets/media/logo/logo.png" alt="Logo" width="170" height="125" />
      </router-link>
    </div>
    <!-- End:: Logo -->

    <!-- Start:: Side Nav Links -->
    <div class="side_nav_links_wrapper">
      <!-- Start:: Home Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')">
        <router-link to="/home">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/home.svg" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.dashboard") }}
          </span>
        </router-link>
      </div>
      <!-- End:: Home Route -->

      <!-- Start::  Roles and Admins Routes-->
      <div class="side_routes_wrapper" v-if="$can('roles index', 'roles') || $can('users index', 'users')">
        <a-menu style="width: 100%" mode="vertical" :open-keys="openKeys" @openChange="onOpenChange">
          <a-sub-menu v-for="item in sideNavbarList_Admins" :key="item.key"
            :data-type="!item.children ? 'single_route' : ''">
            <template v-if="item.children">
              <span slot="title">
                <img :src="item.icon" alt="icon" width="35" height="35" />
                <span> {{ item.title }} </span>
              </span>

              <a-menu-item v-for="childItem in item.children" :key="childItem.key" v-if="childItem.hasPermission">
                <button class="text-start w-100" @click="$emit('fireToggleNavDrawerEmit')">
                  <router-link :to="childItem.route">
                    <i class="fad fa-circle"></i>
                    {{ childItem.title }}
                  </router-link>
                </button>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </a-menu>
      </div>
      <!-- End::  Roles and Admins Routes -->

      <!-- Start:: Admins Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('admins index', 'admins')"
      >
        <router-link to="/admins/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/admins.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.adminsManeg") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: Admins Route -->
      <!-- Start:: Capacities Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('capacities index', 'capacities')">
        <router-link to="/Capacities/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/orders.png" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.Capacities") }}
          </span>
        </router-link>
      </div>
      <!-- End:: Admins Route -->

      <!-- Start:: users Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('users index', 'users')"
      >
        <router-link to="/users/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/users.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.manage_users") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: users Route -->

      <!-- Start:: users Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('clients index', 'clients')">
        <router-link to="/Clients/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/clients.svg" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.Clients.title") }}
          </span>
        </router-link>
      </div>
      <!-- End:: users Route -->

      <!-- Start:: main_sections Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('sections index', 'sections')">
        <router-link to="/main-categories/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/bill.svg" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.main_store_categories") }}
          </span>
        </router-link>
      </div>
      <!-- End:: main_sections Route -->

      <!-- Start:: sub_sections Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('subsections index', 'subsections')">
        <router-link to="/sub-categories/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/folder.png" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.sub_store_categories") }}
          </span>
        </router-link>
      </div>
      <!-- End:: sub_sections Route -->

      <!-- Start:: Product categories Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('categories index', 'categories')">
        <router-link to="/product-categories/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/box.svg" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.product_categories") }}
          </span>
        </router-link>
      </div>
      <!-- End:: Product categories Route -->

      <!-- Start:: sizes Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('sizes index', 'sizes')">
        <router-link to="/sizes/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/text-size.png" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.product_sizes") }}
          </span>
        </router-link>
      </div>
      <!-- End:: sizes Route -->

      <!-- Start:: additions Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('additions index', 'additions')">
        <router-link to="/additions/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/added.png" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.addons_management") }}
          </span>
        </router-link>
      </div>
      <!-- End:: additions Route -->

      <!-- Start:: products Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('products index', 'products')">
        <router-link to="/products/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/product.svg" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.products") }}
          </span>
        </router-link>
      </div>
      <!-- End:: products Route -->

      <!-- Start:: offers Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('offers index', 'offers')">
        <router-link to="/offers/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/offers.svg" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.OffersManagement.title") }}
          </span>
        </router-link>
      </div>
      <!-- End:: offers Route -->

      <!-- Start:: acceptedproviders Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('withdraw_requests index', 'withdraw_requests')"
      >
        <router-link to="/request-wallets/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/bill.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.service_provider_wallet_requests") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: service_provider_wallet_requests Route -->

      <!-- Start:: orders Route -->

      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('orders index', 'orders')">
        <router-link to="/orders/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/paymentmethods.png" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.orders") }}
          </span>
        </router-link>
      </div>
      <!-- End:: orders Route -->

      <!-- Start:: reasons Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('reasonscancellations index', 'reasonscancellations')"
      >
        <router-link to="/reasons/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/cancel.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.reasons") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: reasons Route -->

      <!-- Start:: sideNavbarList_providers Route -->
      <div class="side_routes_wrapper" v-if="
        $can('providers index', 'providers') ||
        $can('providerjoinrequests index', 'providerjoinrequests') ||
        $can(
          'providerjoinrequestmodifications index',
          'providerJoinrequestModifications'
        )
      ">
        <a-menu style="width: 100%" mode="vertical" :open-keys="openKeys" @openChange="onOpenChange">
          <a-sub-menu v-for="item in sideNavbarList_providers" :key="item.key"
            :data-type="!item.children ? 'single_route' : ''" style="border: none">
            <template v-if="item.children">
              <span slot="title">
                <img :src="item.icon" alt="icon" width="35" height="35" />
                <span> {{ item.title }} </span>
              </span>

              <a-menu-item v-for="childItem in item.children" v-if="childItem.hasPermission" :key="childItem.key">
                <button class="text-start w-100" @click="$emit('fireToggleNavDrawerEmit')">
                  <router-link :to="childItem.route">
                    <i class="fad fa-circle"></i>
                    {{ childItem.title }}
                  </router-link>
                </button>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </a-menu>
      </div>
      <div class="side_routes_wrapper" v-if="
        $can('drivers index', 'drivers') ||
        $can('driverjoinrequests index', 'driverjoinrequests') ||
        $can(
          'driverjoinrequestmodifications index',
          'driverjoinrequestmodifications'
        )
      ">
        <a-menu style="width: 100%" mode="vertical" :open-keys="openKeys" @openChange="onOpenChange">
          <a-sub-menu v-for="item in sideNavbarList_driver" :key="item.key"
            :data-type="!item.children ? 'single_route' : ''" style="border: none">
            <template v-if="item.children">
              <span slot="title">
                <img :src="item.icon" alt="icon" width="35" height="35" />
                <span> {{ item.title }} </span>
              </span>

              <a-menu-item v-for="childItem in item.children" v-if="childItem.hasPermission" :key="childItem.key">
                <button class="text-start w-100" @click="$emit('fireToggleNavDrawerEmit')">
                  <router-link :to="childItem.route">
                    <i class="fad fa-circle"></i>
                    {{ childItem.title }}
                  </router-link>
                </button>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </a-menu>
      </div>
      <!-- Start:: sideNavbarList_providers Route -->

      <!-- Start:: RequestWallets Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('requestwallets index', 'requestwallets')">
        <router-link to="/RequestWallets/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/bill.svg" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.Users.wallet-settlement-requests") }}
          </span>
        </router-link>
      </div>
      <!-- End:: RequestWallets Route -->

      <!-- Start:: workplaces Route -->
      <div v-if="$can('workplaces index', 'workplaces')" class="home_route" @click="$emit('fireToggleNavDrawerEmit')">
        <router-link to="/workplaces/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/house.png" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.workplaces") }}
          </span>
        </router-link>
      </div>
      <!-- End:: workplaces Route -->

      <!-- Start:: services Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('services index', 'services')"
      >
        <router-link to="/services/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/service.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.services") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: services Route -->

      <!-- Start:: places Route -->
      <div class="side_routes_wrapper" v-if="
        $can('regions index', 'regions') ||
        $can('states index', 'states') ||
        $can('districts index', 'districts')
      ">
        <a-menu style="width: 100%" mode="vertical" :open-keys="openKeys" @openChange="onOpenChange">
          <a-sub-menu v-for="item in sideNavbarList_Places" :key="item.key"
            :data-type="!item.children ? 'single_route' : ''" style="border: none">
            <template v-if="item.children">
              <span slot="title">
                <img :src="item.icon" alt="icon" width="35" height="35" />
                <span> {{ item.title }} </span>
              </span>

              <a-menu-item v-for="childItem in item.children" v-if="childItem.hasPermission" :key="childItem.key">
                <button class="text-start w-100" @click="$emit('fireToggleNavDrawerEmit')">
                  <router-link :to="childItem.route">
                    <i class="fad fa-circle"></i>
                    {{ childItem.title }}
                  </router-link>
                </button>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </a-menu>
      </div>
      <!-- Start:: places Route -->
      <!-- Start:: reports Route -->
      <!-- <div class="side_routes_wrapper" v-if="$can('reports index', 'reports')">
        <a-menu
          style="width: 100%"
          mode="vertical"
          :open-keys="openKeys"
          @openChange="onOpenChange"
        >
          <a-sub-menu
            v-for="item in sideNavbarListReports"
            :key="item.key"
            :data-type="!item.children ? 'single_route' : ''"
            style="border: none"
          >
            <template v-if="item.children">
              <span slot="title">
                <img :src="item.icon" alt="icon" width="35" height="35" />
                <span> {{ item.title }} </span>
              </span>

              <a-menu-item
                v-for="childItem in item.children"
                :key="childItem.key"
              >
                <button
                  v-if="childItem.hasPermission"
                  class="text-start w-100"
                  @click="$emit('fireToggleNavDrawerEmit')"
                >
                  <router-link :to="childItem.route">
                    <i class="fad fa-circle"></i>
                    {{ childItem.title }}
                  </router-link>
                </button>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </a-menu>
      </div> -->
      <!-- Start:: places Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('districts index', 'districts')"
      >
        <router-link to="/districts/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/village.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.districts") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: districts Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('reports index', 'reports')">
        <router-link to="/finished-orders/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/cardcategories.png" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.Users.financial_reports_finished") }}
          </span>
        </router-link>
      </div>
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('reports index', 'reports')"
      >
        <router-link to="/unfinished-orders/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/cardcategories.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.Users.financial_reports_unfinished") }}
          </span>
        </router-link>
      </div> -->
      <!-- Start:: banks Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('banks index', 'banks')">
        <router-link to="/banks/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/bank.png" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.banks.title") }}
          </span>
        </router-link>
      </div>
      <!-- End:: banks Route -->

      <!-- Start:: packages Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('packages index', 'packages')">
        <router-link to="/packages/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/subscription.png" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.package_management") }}
          </span>
        </router-link>
      </div>
      <!-- End:: packages Route -->

      <!-- Start:: managements Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('management index', 'management')">
        <router-link to="/managements/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/pm.png" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.manage_departments_and_managers") }}
          </span>
        </router-link>
      </div>
      <!-- End:: managements Route -->

      <!-- Start:: ads Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('sliders index', 'sliders')">
        <router-link to="/Ads/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/image.svg" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.ads.title") }}
          </span>
        </router-link>
      </div>
      <!-- End:: ads Route -->

      <!-- Start::financial-reports Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="
          $can('financial_reports unfinishedordersreports', 'financial_reports')
        "
      >
        <router-link to="/financial-reports/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/bill.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.unfinished_orders") }}
          </span>
        </router-link>
      </div> -->
      <!-- End::financial-reports Route -->
      <!-- Start::cardcategories Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('cardcategories index', 'cardcategories')">
        <router-link to="/cardscategories/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/cardcategories.png" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.cardcategories") }}
          </span>
        </router-link>
      </div>
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('cardcategories index', 'cardcategories')">
        <router-link to="/cards/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/cards.png" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.cardsManagement") }}
          </span>
        </router-link>
      </div>
      <!-- End::financial-reports Route -->

      <!-- Start::financial-not-finished-reports Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('reports index', 'reports')"
      >
        <router-link to="/financial-finished-reports/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/areas.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.completed_orders") }}
          </span>
        </router-link>
      </div> -->
      <!-- End::financial-not-finished-reports Route -->

      <!-- Start:: rates Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('ratings index', 'ratings')">
        <router-link to="/app-rate/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/star.svg" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.comments_management") }}
          </span>
        </router-link>
      </div>
      <!-- Start:: rates Route -->

      <!-- Start:: notifications Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('notifications index', 'notifications')">
        <router-link to="/all-notifications/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/notifications.svg" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.notifications.title") }}
          </span>
        </router-link>
      </div>
      <!-- End:: notifications Route -->

      <!-- Start:: app settings Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('settings index', 'settings')">
        <router-link to="/app_settings">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/settings.svg" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.settings.general_app") }}
          </span>
        </router-link>
      </div>
      <!-- End:: app settings Route -->

      <!-- Start:: static pages Side Nav Routes -->
      <div class="side_routes_wrapper" v-if="$can('settings index', 'settings')">
        <a-menu style="width: 100%" mode="vertical" :open-keys="openKeys" @openChange="onOpenChange">
          <a-sub-menu v-for="item in sideNavbarListContentClient" :key="item.key"
            :data-type="!item.children ? 'single_route' : ''" style="border: none">
            <template v-if="item.children">
              <span slot="title">
                <img :src="item.icon" alt="icon" width="35" height="35" />
                <span> {{ item.title }} </span>
              </span>

              <a-menu-item v-for="childItem in item.children" :key="childItem.key" v-if="childItem.hasPermission">
                <button class="text-start w-100" @click="$emit('fireToggleNavDrawerEmit')">
                  <router-link :to="childItem.route">
                    <i class="fad fa-circle"></i>
                    {{ childItem.title }}
                  </router-link>
                </button>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </a-menu>
      </div>
      <!-- <div
        class="side_routes_wrapper"
        
        v-if="$can('settings index', 'settings')"
      >
        <a-menu
          style="width: 100%"
          mode="vertical"
          :open-keys="openKeys"
          @openChange="onOpenChange"
        >
          <a-sub-menu
            v-for="item in sideNavbarListContentProvider"
            :key="item.key"
            :data-type="!item.children ? 'single_route' : ''"
            style="border: none"
          >
            <template v-if="item.children">
              <span slot="title">
                <img :src="item.icon" alt="icon" width="35" height="35" />
                <span style="white-space: normal"> {{ item.title }} </span>
              </span>

              <a-menu-item
                v-for="childItem in item.children"
                :key="childItem.key"
                  v-if="childItem.hasPermission"
              >
                <button
                  class="text-start w-100"
                  @click="$emit('fireToggleNavDrawerEmit')"
                >
                  <router-link :to="childItem.route">
                    <i class="fad fa-circle"></i>
                    {{ childItem.title }}
                  </router-link>
                </button>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </a-menu>
      </div>
      <div
        class="side_routes_wrapper"
        v-if="$can('settings index', 'settings')"
      >
        <a-menu
          style="width: 100%"
          mode="vertical"
          :open-keys="openKeys"
          @openChange="onOpenChange"
        >
          <a-sub-menu
            v-for="item in sideNavbarListContentDriver"
            :key="item.key"
            :data-type="!item.children ? 'single_route' : ''"
            style="border: none"
          >
            <template v-if="item.children">
              <span slot="title">
                <img :src="item.icon" alt="icon" width="35" height="35" />
                <span class="route_text"> {{ item.title }} </span>
              </span>

              <a-menu-item
                v-for="childItem in item.children"
                :key="childItem.key"
                  v-if="childItem.hasPermission"
              >
                <button
                  class="text-start w-100"
                  @click="$emit('fireToggleNavDrawerEmit')"
                >
                  <router-link :to="childItem.route">
                    <i class="fad fa-circle"></i>
                    {{ childItem.title }}
                  </router-link>
                </button>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </a-menu>
      </div> -->
      <!-- End:: static pages Side Nav Routes -->

      <!-- Start:: contacts Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')" v-if="$can('contacts index', 'contacts')">
        <router-link to="/contact-messages/all">
          <span class="route_icon">
            <img src="@/assets/media/icons/ui_icons/messages.svg" alt="icon" width="40" height="40" />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.ContactMessages.title") }}
          </span>
        </router-link>
      </div>
      <!-- End:: contacts Route -->

      <div class="side_routes_wrapper">
        <a-menu style="width: 100%" mode="inline">
          <!-- Start:: Logout Tab -->
          <a-sub-menu key="logout" @titleClick="logoutConfirmationModalIsOpen = true">
            <!-- ========= Start:: Main Tab -->
            <span slot="title" class="logout_btn">
              <img src="../../assets/media/icons/ui_icons/logout.svg" alt="icon" width="35" height="35" />
              <span>
                {{ $t("SIDENAV.Logout.title") }}
              </span>
            </span>
            <!-- ========= End:: Main Tab -->
          </a-sub-menu>
          <!-- End:: Logout Tab -->
        </a-menu>
      </div>
      <!-- End:: Side Nav Routes -->

      <!-- Start:: Logout Confirmation Modal -->
      <v-dialog v-model="logoutConfirmationModalIsOpen">
        <v-card>
          <v-card-title class="text-h5 justify-center">
            {{ $t("TITLES.logoutConfirmingMessage") }}
          </v-card-title>
          <v-card-actions>
            <v-btn class="modal_confirm_btn" @click="logout">{{
              $t("BUTTONS.logout")
            }}</v-btn>

            <v-btn class="modal_cancel_btn" @click="logoutConfirmationModalIsOpen = false">{{ $t("BUTTONS.cancel")
            }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- End:: Logout Confirmation Modal -->
    </div>
  </div>
  <!-- End:: Side Nav Links -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SideNav",

  emits: ["fireToggleNavDrawerEmit"],

  props: {
    navIsActive: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    // Start:: Vuex Get Authenticated User Data
    ...mapGetters({
      getAppTheme: "AppThemeModule/getAppTheme",
      getAuthenticatedUserData: "AuthenticationModule/getAuthenticatedUserData",
    }),
    // End:: Vuex Get Authenticated User Data

    // Start:: Extract Side Nav Keys
    extractSideNavItemsKeys() {
      let extractedKeys = [];
      this.sideNavbarList_Admins?.forEach((element) => {
        extractedKeys.push(element["key"]);
      });
      this.sideNavbarList_Places?.forEach((element) => {
        extractedKeys.push(element["key"]);
      });

      this.sideNavbarList?.forEach((element) => {
        extractedKeys.push(element["key"]);
      });
      // this.sideNavbarList_Rates.forEach((element) => {
      //   extractedKeys.push(element["key"]);
      // });
      return extractedKeys;
    },

    // End:: Extract Side Nav Keys
  },

  data() {
    return {
      // Start:: Controle Open Tabs Data
      openKeys: [],
      // End:: Controle Open Tabs Data

      // Start:: Side Navbar List
      sideNavbarList_Admins: [
        {
          key: "dashboard",
          title: this.$t("SIDENAV.control_admins"),
          icon: require("@/assets/media/icons/ui_icons/panel.png"),
          hasPermission: this.$can("roles index", "roles"),
          children: [
            {
              key: "roles",
              title: this.$t("SIDENAV.Roles.title"),
              route: "/roles/all",
              hasPermission:
                this.$can("roles index", "roles") ||
                this.$can("permissions index", "permissions"),
            },
            {
              key: "admins",
              title: this.$t("SIDENAV.Admins.title"),
              route: "/admins/all",
              hasPermission: this.$can("users index", "users"),
            },
          ],
        },
      ],

      sideNavbarList_Places: [
        {
          key: "dashboard_places",
          title: this.$t("PLACEHOLDERS.places"),
          icon: require("@/assets/media/icons/ui_icons/country.png"),
          hasPermission:
            this.$can("districts index", "districts") ||
            this.$can("regions index", "regions") ||
            this.$can("states index", "states"),
          children: [
            {
              key: "states",
              title: this.$t("PLACEHOLDERS.municipality_management"),
              route: "/states/all",
              hasPermission: this.$can("states index", "states"),
            },
            {
              key: "regions",
              title: this.$t("PLACEHOLDERS.manage_regions"),
              route: "/regions/all",
              hasPermission: this.$can("regions index", "regions"),
            },
            {
              key: "districts",
              title: this.$t("TITLES.districts"),
              route: "/districts/all",
              hasPermission: this.$can("districts index", "districts"),
            },
          ],
        },
      ],

      // sideNavbarList_users: [
      //   {
      //     key: "users_control",
      //     title: this.$t("PLACEHOLDERS.manage_users"),
      //     icon: require("@/assets/media/icons/ui_icons/clients.svg"),
      //     hasPermission: this.$can("users index", "users"),
      //     children: [
      //       {
      //         key: "users",
      //         title: this.$t("PLACEHOLDERS.manage_all_users"),
      //         route: "/clients/all",
      //         hasPermission: this.$can("users index", "users"),
      //       },
      //     ],
      //   },
      // ],

      sideNavbarListContentClient: [
        {
          key: "appContent",
          title: this.$t("SIDENAV.AppContent.title"),
          icon: require("@/assets/media/icons/ui_icons/book_mark.svg"),
          children: [
            {
              key: "contact",
              title: this.$t("PLACEHOLDERS.contact_admins"),
              route: "/contact_settings",
              hasPermission: this.$can("settings create", "settings"),
            },
            {
              key: "AboutUs",
              title: this.$t("SIDENAV.AppContent.aboutUs"),
              route: "/app-content/about-us-client",
              hasPermission: this.$can("settings index", "settings"),
            },
            {
              key: "TermsAndConditions",
              title: this.$t("SIDENAV.AppContent.termsAndConditions"),
              route: "/app-content/terms-client",
              hasPermission: this.$can("settings index", "settings"),
            },
            {
              key: "PrivacyPolicy",
              title: this.$t("SIDENAV.AppContent.privacyPolicy"),
              route: "/app-content/policy-client",
              hasPermission: this.$can("settings index", "settings"),
            },
            {
              key: "delete-account",
              title: this.$t("PLACEHOLDERS.how_to_delete_account"),
              route: "/app-content/delete-account",
              hasPermission: this.$can("settings index", "settings"),
            },
          ],
        },
      ],
      //    sideNavbarListContentDriver: [
      //    {
      //     key: "appContentDriver",
      //     title: this.$t("SIDENAV.AppContent.titleDriver"),
      //     icon: require("@/assets/media/icons/ui_icons/book_mark.svg"),
      //     children: [
      //        {
      //         key: "ContactUsDriver",
      //         title: this.$t("SIDENAV.AppContent.contactUsDriver"),
      //         route: "/app-content/contact-us-driver",
      //         hasPermission: this.$can("settings index", "settings"),
      //       },
      //       {
      //         key: "AboutUsDriver",
      //         title: this.$t("SIDENAV.AppContent.aboutUs"),
      //         route: "/app-content/about-us-driver",
      //         hasPermission: this.$can("settings index", "settings"),
      //       },
      //       {
      //         key: "TermsAndConditionsDriver",
      //         title: this.$t("SIDENAV.AppContent.termsAndConditions"),
      //         route: "/app-content/terms-driver",
      //         hasPermission: this.$can("settings index", "settings"),
      //       },
      //       {
      //         key: "PrivacyPolicyDriver",
      //         title: this.$t("SIDENAV.AppContent.privacyPolicy"),
      //         route: "/app-content/policy-driver",
      //         hasPermission: this.$can("settings index", "settings"),
      //       },
      //     ],
      //   },
      // ],
      //    sideNavbarListContentProvider: [
      //  {
      //     key: "appContentProvider",
      //     title: this.$t("SIDENAV.AppContent.titleProvider"),
      //     icon: require("@/assets/media/icons/ui_icons/book_mark.svg"),
      //     children: [
      //        {
      //         key: "ContactUsProvider",
      //         title: this.$t("SIDENAV.AppContent.contactUsProvider"),
      //         route: "/app-content/contact-us-provider",
      //         hasPermission: this.$can("settings index", "settings"),
      //       },
      //       {
      //         key: "AboutUsProvider",
      //         title: this.$t("SIDENAV.AppContent.aboutUs"),
      //         route: "/app-content/about-us-provider",
      //         hasPermission: this.$can("settings index", "settings"),
      //       },
      //       {
      //         key: "TermsAndConditionsProvider",
      //         title: this.$t("SIDENAV.AppContent.termsAndConditions"),
      //         route: "/app-content/terms-provider",
      //         hasPermission: this.$can("settings index", "settings"),
      //       },
      //       {
      //         key: "PrivacyPolicyProvider",
      //         title: this.$t("SIDENAV.AppContent.privacyPolicy"),
      //         route: "/app-content/policy-provider",
      //         hasPermission: this.$can("settings index", "settings"),
      //       },
      //     ],
      //   },
      // ],
      // sideNavbarList_driver: [
      //   {
      //     key: "driver",
      //     title: this.$t("PLACEHOLDERS.control_driver"),
      //     icon: require("@/assets/media/icons/ui_icons/manager.png"),
      //     hasPermission:
      //       this.$can("drivers index", "drivers")
      //       || this.$can("driverjoinrequests index", "driverjoinrequests")
      //      || this.$can(
      //         "driverjoinrequestmodifications index",
      //         "driverjoinrequestmodifications"
      //       ),
      //     children: [
      //       {
      //         key: "driver_join",
      //         title: this.$t("PLACEHOLDERS.driver-join-request"),
      //         route: "/driver-requests/all",
      //         hasPermission: this.$can(
      //           "driverjoinrequests index",
      //           "driverjoinrequests"
      //         ),
      //       },
      //       {
      //         key: "driver_manegment",
      //         title: this.$t("PLACEHOLDERS.driver-manegment"),
      //         route: "/driver-manegment/all",
      //         hasPermission: this.$can("drivers index", "drivers"),
      //       },
      //       {
      //         key: "driver_apdate",
      //         title: this.$t("PLACEHOLDERS.driver-apdate-request"),
      //         route: "/driver-update/all",
      //         hasPermission: this.$can(
      //           "driverjoinrequestmodifications index",
      //           "driverjoinrequestmodifications"
      //         ),
      //       },
      //       {
      //         key: "delivery_agent_wallet_withdraw_requests",
      //         title: this.$t(
      //           "PLACEHOLDERS.delivery_agent_wallet_withdraw_requests"
      //         ),
      //         route: "/driver-requests/driver-wallet",
      //         hasPermission: this.$can("installments index", "installments"),
      //       },
      //     ],
      //   },
      // ],
      // sideNavbarList_providers: [
      //   {
      //     key: "providers",
      //     title: this.$t("PLACEHOLDERS.control_admins"),
      //     icon: require("@/assets/media/icons/ui_icons/manager.png"),
      //     hasPermission:
      //       this.$can("providers index", "providers")
      //       || this.$can("providerjoinrequests index", "providerjoinrequests")
      //       || this.$can(
      //         "providerjoinrequestmodifications index",
      //         "providerJoinrequestModifications"
      //       ),
      //     children: [
      //       {
      //         key: "providers_join",
      //         title: this.$t("PLACEHOLDERS.admins-join-request"),
      //         route: "/admins-requests/all",
      //         hasPermission: this.$can(
      //           "providerjoinrequests index",
      //           "providerjoinrequests"
      //         ),
      //       },
      //       {
      //         key: "providers_manegment",
      //         title: this.$t("PLACEHOLDERS.admins-manegment"),
      //         route: "/admins-manegment/all",
      //         hasPermission: this.$can("providers index", "providers"),
      //       },
      //       {
      //         key: "providers_apdate",
      //         title: this.$t("PLACEHOLDERS.admins-apdate-request"),
      //         route: "/admins-update/all",
      //         hasPermission: this.$can(
      //           "providerjoinrequestmodifications index",
      //           "providerjoinrequestmodifications"
      //         ),
      //       },
      //       {
      //         key: "service_provider_wallet_requests",
      //         title: this.$t("PLACEHOLDERS.service_provider_wallet_requests"),
      //         route: "/admins-requests/provider-wallet",
      //         hasPermission: this.$can("installments index", "installments"),
      //       },
      //     ],
      //   },
      // ],

      sideNavbarList_Rates: [
        {
          key: "rates",
          title: this.$t("PLACEHOLDERS.comments_management"),
          icon: require("@/assets/media/icons/ui_icons/star.svg"),
          hasPermission: this.$can("ratings index", "ratings"),
          route: "/app-rate/all",
        },
      ],

      sideNavbarList_Contact_Messages: [
        {
          key: "contact-messages",
          title: this.$t("SIDENAV.ContactMessages.title"),
          icon: require("@/assets/media/icons/ui_icons/star.svg"),
          hasPermission: this.$can("contacts index", "contacts"),
          route: "/contact-messages/all",
        },
      ],

      sideNavbarList_providers: [
        {
          key: "providers",
          title: this.$t("PLACEHOLDERS.control_admins"),
          icon: require("@/assets/media/icons/ui_icons/manager.png"),
          hasPermission:
            this.$can("providers index", "providers") ||
            this.$can("providerjoinrequests index", "providerjoinrequests") ||
            this.$can(
              "providerjoinrequestmodifications index",
              "providerJoinrequestModifications"
            ),
          children: [
            {
              key: "providers_join",
              title: this.$t("PLACEHOLDERS.admins-join-request"),
              route: "/admins-requests/all",
              hasPermission: this.$can(
                "providerjoinrequests index",
                "providerjoinrequests"
              ),
            },
            {
              key: "providers_manegment",
              title: this.$t("PLACEHOLDERS.admins-manegment"),
              route: "/providers/all",
              hasPermission: this.$can("providers index", "providers"),
            },
            {
              key: "providers_apdate",
              title: this.$t("PLACEHOLDERS.admins-apdate-request"),
              route: "/admins-update/all",
              hasPermission: this.$can(
                "providerjoinrequestmodifications index",
                "providerjoinrequestmodifications"
              ),
            },
            {
              key: "service_provider_wallet_requests",
              title: this.$t("PLACEHOLDERS.service_provider_wallet_requests"),
              route: "/admins-requests/provider-wallet",
              hasPermission: this.$can("installments index", "installments"),
            },
          ],
        },
      ],
      sideNavbarList_driver: [
        {
          key: "driver",
          title: this.$t("PLACEHOLDERS.control_driver"),
          icon: require("@/assets/media/icons/ui_icons/manager.png"),
          hasPermission:
            this.$can("drivers index", "drivers") ||
            this.$can("driverjoinrequests index", "driverjoinrequests") ||
            this.$can(
              "driverjoinrequestmodifications index",
              "driverjoinrequestmodifications"
            ),
          children: [
            {
              key: "driver_join",
              title: this.$t("PLACEHOLDERS.driver-join-request"),
              route: "/driver-requests/all",
              hasPermission: this.$can(
                "driverjoinrequests index",
                "driverjoinrequests"
              ),
            },
            {
              key: "driver_manegment",
              title: this.$t("PLACEHOLDERS.driver-manegment"),
              route: "/driver-manegment/all",
              hasPermission: this.$can("drivers index", "drivers"),
            },
            {
              key: "driver_apdate",
              title: this.$t("PLACEHOLDERS.driver-apdate-request"),
              route: "/driver-update/all",
              hasPermission: this.$can(
                "driverjoinrequestmodifications index",
                "driverjoinrequestmodifications"
              ),
            },
            {
              key: "delivery_agent_wallet_withdraw_requests",
              title: this.$t(
                "PLACEHOLDERS.delivery_agent_wallet_withdraw_requests"
              ),
              route: "/driver-requests/driver-wallet",
              hasPermission: this.$can("installments index", "installments"),
            },
          ],
        },
      ],

      // Start:: Modal Controlling Data
      logoutConfirmationModalIsOpen: false,
      // End:: Modal Controlling Data
    };
  },

  methods: {
    // Start:: Vuex Auth Actions
    ...mapActions({
      logout: "AuthenticationModule/logout",
    }),
    // End:: Vuex Auth Actions
    handleClick() {
      this.open = !this.open;
    },
    closeMenu() {
      this.open = false;
    },

    handleClickOrder() {
      this.openOrder = !this.openOrder;
    },
    closeMenuOrder() {
      this.openOrder = false;
    },
    handleClickcities() {
      this.openCities = !this.openCities;
    },
    closeMenuCities() {
      this.openCities = false;
    },
    // Start:: Controle Open Tabs
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (this.extractSideNavItemsKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    // End:: Controle Open Tabs
  },

  created() { },
};
</script>
